<template>
    <div>
        <!-- <div v-if="productExists & displayReady & mode=='big'"> -->
        <!-- Display 1 - Full details -->
        <div v-if="mode=='big'">
            <div class="panel-container">
                <div v-if="pageListPtr>0" class="left-arrow scroll-button" @click="backScroll()">
                    <!-- <img :src="backimage"/> -->
                    <svg style="width:36px;height:36px" viewBox="0 0 24 24">
                        <path fill="gray" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                    </svg>
                </div>
                <div v-else class="left-arrow scroll-button">
                  &nbsp;
                </div>
                <div class="panel-grid" :style="panelStyle">
                    <div v-for="(fmlproduct,index) in pageList[pageListPtr]" :key="index" :xstyle="{width:panelWidth}" class='product-panel'>
                        <product-panel 
                              :product="fmlproduct" 
                              fmlCtrl="true" 
                              :highlight="highlight" 
                              :eventSource="eventSource" 
                              sbButtonText="Find More"
                              :design="design"
                              @findMore="findMore">
                        </product-panel>
                    </div>
                </div>
                <div v-if="scroll=='true' && moreProducts" class="scroll-button right-arrow" @click="frontScroll()">
                    <!-- <img :src="moreimage"/> -->
                    <svg style="width:36px;height:36px" viewBox="0 0 24 24">
                        <path fill="gray" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                    </svg>
                </div>
            </div>
        </div>
        <!-- <div v-if="(!productExists | noSimilars) & type=='inpage'" class="display-font message"> -->


        <!-- Display 2 - Product not found -->

        <div v-if="type=='sticky' & widgetState=='noproducts'" class="display-font message">
            <div>&nbsp;</div>
            <h3 class="">Oops, it looks like this product has not been indexed.</h3>
            <div>Please try another product or this one again later.</div>
        </div>


        <!-- Display 3 - Icons for Float -->

        <div v-if="mode=='small' & widgetState=='display'" class="icon-panel" >
            <h4 class="small-header">Similar</h4>
            <div class="icon-grid" @click="expandIcons()" :style="design">
                <div v-for="(product,index) in pageList[pageListPtr]" :key="index">
                    <img :src="product.image">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Vuetify from 'vuetify'
// import goTo from 'vuetify/es5/services/goto'
//import VueAxios from 'vue-axios'
// import {HTTP} from '../sbcore/http-common.js'

// import SimilarRow from './SimilarRow';
import ProductPanel from './ProductPanel'
// import {VApp, VCard} from 'vuetify/lib'

// import Vue from 'vue'

let site = require(process.env.VUE_APP_SITE_JS)

export default {
  // components: {VApp, VCard},
  // components: {SimilarRow,VApp, VCard},
  components : {ProductPanel},
  props : {
    'productid' : String,
    'showseed' : String,
    'design' : Object,
    'number' : {
      type : Number,
      default : 4
    },
    'scroll' : {
      type : String,
      default : "true"
    },
    'highlight' : {
      type : String,
      default : "false"
    },
    'type' : {
      type : String,
      default : "sticky"
    },
    'mode' : {
      type : String,
      default : 'big'
    },
    sb : Object
  },
  data: () => ({
    // seedProduct : null,
    seedProductid : null,
    pageList : [],
    pageListPtr : 0,
    // history : [],
    // errors:[],
    // panelCols : 2,
    // serverURL : process.env.VUE_APP_SERVER_URL,
    imagesURL : site.imagesURL,
    // sectionWidth : 0,
    productExists : true,
    // noSimilars : false,
    // visibility : "hidden",
    screenNumber : null,
    // widgetClasses : {},
    // allClasses : ['product-price'],
    // displayReady : false,
    eventSource : 'similar_unknown',
    widgetState : 'hide'   // other states - loading, noproducts, nomore, display
  }),
  methods : {
    expandIcons() {
      this.$emit('updateMode','big')

      let data = {
        'sbAction' : 'Expand',
        'productid' : this.productid,
        'source' : this.eventSource,
        'page' : window.location.pathname+window.location.search
      }
      this.sb.sendEvent('sbaction',data)
    },
    findMore: function (args) {
      this.updateSimilar(args.product,true)
    },
    frontScroll : function (){
      this.updateSimilar(this.seedProduct,true)
    },
    backScroll: function () {
      this.pageListPtr = Math.max(0,this.pageListPtr-1)
        this.widgetState = 'display'
      // this.$root.$emit('backScroll',{product:this.product,excludeHistory:true})
    },
    updateSimilar(product,excludeHistory) {

      // this.noSimilars = false

      if (this.pageListPtr < this.pageList.length-1) {
        this.pageListPtr = this.pageListPtr+1
        this.widgetState = 'display'
        // this.displayReady = true
      } else {
        this.widgetState = 'loading'
        this.seedProduct = product
        // this.seedProductid = product.productid
        // this.$root.$emit('setFocus','fml')

        let brandConstraint = this.type!='sticky' ? 1 : 0;
        setTimeout(()=>{

        this.sb.getSimilarProducts(product,this.screenNumber,excludeHistory,brandConstraint,((slist) => {
          if(site.debug) {
            console.log('SimilarProducts returned',slist)
          }
            if (slist.length==0) {
              this.widgetState = (excludeHistory==false) ? 'noproducts' : 'nomore'
            } else {
              let ps = []
              for (let s of slist) {
                this.sb.getProductObject(s,(p)=>{
                  ps.push(p)
                  if (ps.length == slist.length) {
                    this.pageList.push(ps) //.slice(0)
                    this.pageListPtr = this.pageList.length - 1

                    let sbAction = ''
                    if (ps.length == 0) {
                      this.widgetState = (excludeHistory==false) ? 'noproducts' : 'nomore'
                      sbAction = 'Display-NoProducts'
                    } else {
                      this.widgetState = 'display'
                      sbAction = 'Display'
                    }

                    let data = {
                    'sbAction' : sbAction,
                    'productid' : product.productid,
                    'source' : this.eventSource,
                    'page' : window.location.pathname+window.location.search
                    }
                    this.sb.sendEvent('sbaction',data)
                  }
                })
              }
            }
          }
        ))
        },0)
      }
    },
  },
  mounted () {

    // Reduce the number asked for if the screen is narrow. This will work down to 2 for a 
    // mobile screen of 320px
    this.screenNumber = Math.min(this.number,Math.floor(window.innerWidth / 160))


    //
    // If there is a seed fml then run it. If not just shwo whatever history there is 
    //
    this.seedProductid = this.productid

    // this.$root.$on('addFml', args => {
    //   this.updateSimilar(args.product,args.excludeHistory)
    // })

    // if (this.type=="inpage") {
    //   this.visibility = "visible"
    // } else {
    //   this.visibility = "hidden"
    // }

    this.eventSource = 'similar_'+this.type

  },
  computed : {
    //   productHeight : function () {
    //   if (this.fullDisplay) { 
    //     return window.innerHeight/2
    //   } else {
    //     return window.innerHeight/8
    //   }
    // },
    moreimage : function (){return this.imagesURL+"arrow-right.svg"},
    backimage : function (){return this.imagesURL+"arrow-left.svg"},
    panelWidth : function () {
      return this.sb.panelWidth(85,this.screenNumber)
    },
    // highlightColor : function () {return this.highlight=="true" ? "LightGrey" : "white"},
    moreProducts : function () {
      return this.pageList.length > 0 && this.pageList[this.pageListPtr].length == this.screenNumber && (this.widgetState != 'nomore')},
    panelStyle : function () {
      return {
        '--number-products':(this.pageList[this.pageListPtr]!=undefined) ? this.pageList[this.pageListPtr].length : 0
      }
    },

  },
  watch : {
    widgetState : function () {
      this.$emit('updateWidgetState',this.widgetState)
    },
    // displayReady : function () {
    //   this.$emit('displayReady',this.displayReady && !this.noSimilars)
    // },
    productid : function () {this.seedProductid = this.productid},
    seedProductid: function () {
      if (site.debug) {
        console.log('Seed product changed',this.seedProductid)
      }
         if (this.seedProductid != "" && this.seedProductid != undefined) {
            // this.displayReady = false

            this.pageList = []
              // get the product Details
              this.sb.getProductObject(this.seedProductid, (product) => {

                  if (product.productid != undefined) {
                    // this.productExists = true
                    this.updateSimilar(product,false)
                  } else {
                    this.widgetState = 'noproducts'
                  }
              })
            } 
    }
  }
};
</script>
<style scoped>

/*@media only screen and (max-width: 768px) {
  .scroll-button  {
    width : 24px;
    height : 24px;
  }
}
*/
.scroll-button {
  cursor : pointer;
  display : flex;
  -ms-align-items: center;
  align-items: center;
}


.scroll-button svg {
  border : 1px solid gray;
  border-radius : 50%;
}

.scroll-button:hover svg {
      background-color: var(--controls-color);
      border-color: var(--controls-color);
}

.scroll-button:hover svg path {
  fill : white;
}

.panel-container {
    /*border : var(--border)   ;*/
    /*background-color: var(--background-color) ;      */
    display : grid;
    grid-template-columns: 40px auto 40px;
    grid-template-areas: 
      "leftside panels rightside";
    align-items: center;
    column-gap : 3px;
    max-width : 100%;
}
  
/*
####
@media only screen and (max-width: 768px) {
  .panel-container {
      display : grid;
      grid-template-columns: 10% 80% 10%;
      grid-template-areas: 
        "leftside panels rightside";
      align-items: center;
      column-gap : 3px;
      max-width : 100%;
  }
}
*/

.panel-container {
    /*border : var(--border)   ;*/
    /*background-color: var(--background-color) ;      */
    display : grid;
    grid-template-columns: 40px auto 40px;
    grid-template-areas: 
      "leftside panels rightside";
    justify-items: center;
    column-gap : 10px;
}

  .panel-grid {
      grid-area : panels;
      display : grid;
      /*grid-template-columns: repeat(var(--number),1fr);*/
      grid-template-columns: repeat(var(--number-products),auto);
      /*grid-template-columns: repeat(2,auto);*/
      grid-column-gap: 50px;
  }

@media only screen and (max-width: 768px) {

  .panel-grid {
      grid-column-gap: 10px;
  }
}

.left-arrow {
  grid-area : leftside;
  justify-self : end;
}

.right-arrow {
  grid-area : rightside;
  justify-self : start;
}

.icon-grid {
  /*border : var(--border);*/
  cursor : pointer;
  width : min-content;
  display : grid;
/*  grid-template-columns: repeat(3, auto);*/     /* number */
  /*grid-template-columns: auto;    */
  grid-template-columns: var(--icon-columns);    
  grid-template-rows : 1fr;
  padding : 3px;
  justify-content: start;
}


.icon-grid img {
  width : var(--icon-width);
  height : var(--icon-height);
}


.icon-panel {
  /*background-color: var(--background-color);*/
  /*border : var(--border);*/
}

.icon-panel h4 {
  text-align: center;
  margin : 0;
}

.message {
  white-space: nowrap;
  padding : 50px;
  padding-top : 10px;
}

@media only screen and (max-width: 768px) {
  .message {
    white-space: pre-wrap;
    padding : 50px;
    padding-top : 10px;  }
}

</style>